/**
 * Frontend JavaScript for MR Blocks Slider using Splide.js
 */

document.addEventListener("DOMContentLoaded", function () {
	console.log("MR Blocks Slider: DOM loaded, initializing sliders...");

	// Function to initialize a single slider
	function initializeSlider(sliderElement) {
		console.log("Initializing slider:", sliderElement);

		// Get the splide element
		const splideElement = sliderElement.querySelector(".splide");
		if (!splideElement) {
			console.warn("No .splide element found in slider");
			return;
		}

		// Get configuration from data attribute
		let config = {};
		try {
			const configData = splideElement.getAttribute("data-splide");
			if (configData) {
				config = JSON.parse(configData);
			}
		} catch (error) {
			console.warn("Error parsing slider configuration:", error);
		}

		// Default configuration
		const defaultConfig = {
			type: "loop",
			perPage: 1,
			gap: 0,
			peek: 0,
			autoplay: false,
			pauseOnHover: true,
			pauseOnFocus: true,
			easing: "ease",
			arrows: true,
			pagination: true,
			breakpoints: {
				800: {
					perPage: 1,
					peek: 0,
					gap: 0,
				},
			},
		};

		// Merge configurations
		const finalConfig = { ...defaultConfig, ...config };

		finalConfig.breakpoints[768] = {
			arrows: true,
			pagination: true,
		};

		console.log("Slider configuration:", finalConfig);

		// Wait for Splide.js to be available
		function waitForSplide() {
			if (typeof window.Splide !== "undefined") {
				console.log("Splide.js is available, creating instance");
				try {
					// Create and mount the Splide instance
					const splide = new window.Splide(splideElement, finalConfig);
					splide.mount();
					console.log("Slider initialized successfully");
				} catch (error) {
					console.error("Error initializing Splide slider:", error);
				}
			} else {
				console.log("Splide.js not yet available, retrying...");
				setTimeout(waitForSplide, 100);
			}
		}

		waitForSplide();
	}

	// Initialize all sliders on the page
	function initializeAllSliders() {
		const sliders = document.querySelectorAll(".wp-block-mr-blocks-slider");
		console.log(`Found ${sliders.length} slider(s) to initialize`);

		sliders.forEach((slider, index) => {
			console.log(`Initializing slider ${index + 1}/${sliders.length}`);
			initializeSlider(slider);
		});
	}

	// Initialize sliders
	initializeAllSliders();

	// Re-initialize sliders when new content is loaded (for AJAX/dynamic content)
	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.type === "childList") {
				mutation.addedNodes.forEach(function (node) {
					if (node.nodeType === Node.ELEMENT_NODE) {
						// Check if the added node is a slider or contains sliders
						const sliders = node.classList?.contains(
							"wp-block-mr-blocks-slider",
						)
							? [node]
							: node.querySelectorAll?.(".wp-block-mr-blocks-slider") || [];

						if (sliders.length > 0) {
							console.log(
								`Found ${sliders.length} new slider(s), initializing...`,
							);
							sliders.forEach(initializeSlider);
						}
					}
				});
			}
		});
	});

	// Start observing
	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});

	console.log("MR Blocks Slider: Initialization complete");
});
